export default __webpack_public_path__ + "static/media/crd.b8422671.svg";